import { useAppNavigation } from '@v2/domains/routing/hooks/useAppNavigation.hook'

const navigationState: {
  navigate?: (path: string) => void
  location?: {
    pathname: string
    search: string
    hash: string
    state: any
  }
} = {
  navigate: undefined,
  location: undefined,
}

const useRouter = () => {
  const { push } = useAppNavigation()

  return {
    push,
    navigate: (path: string) => {
      push(path, { includeOrgPrefix: true })
    },
  }
}

export { useRouter, navigationState }
